<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <!--매출현황 -->
        <piaf-breadcrumb :heading="$t('menu.report')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-row>
            <b-colxx xxs="12" md="12" lg="12" xl="12">
              <div class="form-group has-float-label reoportDiv newMnp">
                <b-input-group>
                  <template v-slot:prepend>
                    <b-input-group-text>
                      <b-icon icon="calendar"></b-icon>
                    </b-input-group-text>
                  </template>
                  <vue-monthly-picker
                  class="newmm"
                    v-model="date.startDate"
                    :clearOption="false"
                    dateFormat="YYYY-MM"
                    :monthLabels="['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']"
                    selectedBackgroundColor="#c11314"
                    alignment="center"
                  >
                  <!--  @selected="setEndDate" -->
                  <!-- :min="date.startMinDate"
                    :max="date.startMaxDate" -->
                  </vue-monthly-picker>
                  </b-input-group>
                  <span>시작일</span>
                </div>
            <!-- </b-colxx>
            <b-colxx xxs="12" md="6" lg="3" xl="3"> -->
              <div class="form-group has-float-label reoportDiv newMnp">
                <b-input-group>
                 <template v-slot:prepend>
                    <b-input-group-text>
                      <b-icon icon="calendar"></b-icon>
                    </b-input-group-text>
                  </template>
                  <vue-monthly-picker
                  class="newmm"
                    v-model="date.endDate"
                    :clearOption="false"
                    dateFormat="YYYY-MM"
                    :monthLabels="['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']"
                    selectedBackgroundColor="#c11314"
                    alignment="center"
                    @selected="setStartDate"
                  >
                  <!-- :min="date.endMinDate"
                    :max="date.endMaxDate" -->
                  </vue-monthly-picker>
                </b-input-group>
                <span>종료일</span>
              </div>
              
            <div v-if="userRole === 'BRAND'" class="reoportDiv form-group">
              <v-select :options="storeList" v-model="searchStoreSelect" size="sm" label="label" class="pl-1" :reduce="item=>item.value"
                          style="width:200px;"></v-select>
            </div>
            <div class="reoportDiv mb-3">
              <b-button variant="primary default" class="ml-0 mr-2" @click="getChartData">검색</b-button>
            </div>
            </b-colxx>
          </b-row>
        </b-card>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-row>
            <canvas id="planet-chart" width="500" height="100"></canvas>
          </b-row>
        </b-card>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" :title="`매출내역 (${this.$moment(date.startChartDate).format('YYYY년 MM월')} ~ ${this.$moment(date.endChartDate).format('YYYY년 MM월')})`">
          <b-row class="">
            <b-col md="4" class="text-left" align-v="left">
              <b-form-group> 
                <b-form-radio-group v-model="typeSelect.value" @change="createChart" size="sm" class="pt-3">
                  <b-form-radio value="transactionAmount" >판매가</b-form-radio>
                  <b-form-radio value="salesDeliveryAmount" >입금가</b-form-radio>
                  <b-form-radio value="salesCommission">수수료</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col class="text-right noHegith pr-0" >
              <b-button size="sm" variant="outline-success default" class="mb-0" @click="createChartExcel">Excel</b-button>

            </b-col>
          </b-row>

          <b-row>
            <div style="width:100%; overflow:scroll; ">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <td style="min-width:150px; text-align:center;">매장명</td>
                    <td v-for="(label, index) in chartLabels" v-bind:key="index" style="text-align:center">
                      {{label}}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in storeSelect ? [chartData[typeSelect.value].find(o => o.code == storeSelect)] : chartData[typeSelect.value]" v-bind:key="index" >
                    <td style="text-align:center">{{row.label}}</td>
                    <td v-for="(each , index) in row.data" v-bind:key="index" style="text-align:right">
                      {{typeof (each) === "number" ? each.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") : ""}}
                    </td>
                  </tr>
                  <tr v-if="userRole === 'BRAND'">
                    <td style="text-align:center">합계</td>
                    <td v-for="(each , index) in totalData[typeSelect.value]" v-bind:key="index" style="text-align:right">
                      {{typeof (each) === "number" ? each.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") : ""}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-row>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
  import {alignTableCenter, currencyFilter} from "../../utils";
  import Chat from 'chart.js'
  import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
  import api from "../../constants/api"
  import axios from "axios"
  import xlsx from "xlsx"

  export default {
    filters: {...currencyFilter},
    components:{
      'v-select':vSelect
    },
    data() {
      return {
        userRole: null,
        date: {
          startDate: this.$moment(new Date().setMonth(new Date().getMonth()-13)),
          startMinDate: this.$moment(new Date().setMonth(new Date().getMonth()-13)),
          startMaxDate: this.$moment(new Date().setMonth(new Date().getMonth()-1)),
          endDate: this.$moment(new Date().setMonth(new Date().getMonth()-1)),
          endMinDate: this.$moment(new Date().setMonth(new Date().getMonth()-14)),
          endMaxDate: this.$moment(new Date().setMonth(new Date().getMonth()-1)),
          startChartDate: this.$moment(new Date().setMonth(new Date().getMonth()-13)),
          endChartDate: this.$moment(new Date().setMonth(new Date().getMonth()-1))
        },
        storeList: [{label: '전매장', value: null}],
        searchStoreSelect: null,
        storeSelect: null,
        typeList: [
          {label:'판매가', value: 'transactionAmount'},
          {label:'입금가', value: 'salesDeliveryAmount'},
          {label:'수수료', value: 'salesCommission'},
        ],
        typeSelect: {label:'판매가', value: 'transactionAmount'},
        chartLabels: [],
        chartData: {
          transactionAmount:[],
          salesDeliveryAmount: [],
          salesCommission: []
        },
        totalData: {
          transactionAmount:[],
          salesDeliveryAmount: [],
          salesCommission: []
        }
      }
    },
    created() {

    },
    async mounted() {
      this.userRole = this.currentUser.userRole.split('_')[0]
      this.getStoreList()
      this.getChartData()
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName']),
    },
    methods: {
      setStartDate(arg) {
        this.$set(this.date, "startMinDate", this.$moment(arg.add(-12, 'M')))
        this.$set(this.date, "startMaxDate", this.$moment(arg.add(11, 'M')))
      },
      setEndDate(arg) {
        this.$set(this.date, "endDate", null)
        this.$set(this.date, "endMinDate", this.$moment(arg.add(1, 'M')))
        this.$set(this.date, "endMaxDate", this.$moment(arg.add(11, 'M')))
      },
      async getStoreList() {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.brandStoreCodeSearch)
        
        let list = await axios({
          headers: {
            "Authorization" : `Bearer ${this.currentUser.tokens.access.token}`
          },
          method: 'get',
          url: reqURL
        })
        list.data.data.forEach( (value, index) => {
          this.storeList.push({label: value.storeName, value: value.storeCode})
        });
        
      },

      async getChartData() {
        console.log(this.storeList);
        // console.log(this.date.endDate._d)
        // console.log(this.date.endDate._d)
        if(this.date.startDate._d > this.date.endDate._d){
          alert('시작일이 종료일 보다 클 수 없습니다.');
          return false;
        }
        if(this.date.startDate == null || this.date.endDate == null) {
           alert("시작일과 종료일을 설정해주세요")
          return false;
        }
        this.storeSelect = this.searchStoreSelect
        this.createChartLabel();
        
        let apiSubURL = this.userRole == "BRAND" ? api.statistics.completedSettlementsReport : api.statistics.completedSettlementsReportStr
        const reqURL = api.changeAPI(this.siteName, api.basicURL + apiSubURL)
        
        let response = await axios({
          headers: {
            "Authorization" : `Bearer ${this.currentUser.tokens.access.token}`
          },
          method: 'post',
          url: reqURL,
          data: {
            from: this.$moment(this.date.startDate).format("YYYY-MM"),
            to: this.$moment(this.date.endDate).format("YYYY-MM"),
            storeCode: this.storeSelect
          }
        })
        
        let stores = this.userRole == "BRAND" ? response.data.data.brand.stores : [response.data.data.store]

        let chartTAmounts = []
        let chartDAmounts = []
        let chartCommissions = []

        stores.forEach( (row, rowIndex) => {
          let radomColor = "#"+Math.floor(Math.random()*16777215).toString(16)

          chartTAmounts[rowIndex] = { label: row.storeName, code: row.storeCode, data: [], fill: false, borderColor: radomColor}
          chartDAmounts[rowIndex] = { label: row.storeName, code: row.storeCode, data: [], fill: false, borderColor: radomColor}
          chartCommissions[rowIndex] = { label: row.storeName, code: row.storeCode, data: [], fill: false, borderColor: radomColor}

          this.chartLabels.forEach( (labelDate, labelIndex) => {
            let matchData = row.yearMonths.find(o => o.yearMonth === labelDate)

            chartTAmounts[rowIndex].data[labelIndex] = typeof matchData === "undefined" ? '' : Number(matchData.transactionAmount)
            chartDAmounts[rowIndex].data[labelIndex] = typeof matchData === "undefined" ? '' : Number(matchData.salesDeliveryAmount)
            chartCommissions[rowIndex].data[labelIndex] = typeof matchData === "undefined" ? '' : Number(matchData.salesCommission)

          })
        })

        this.$set(this.chartData, 'transactionAmount', chartTAmounts)
        this.$set(this.chartData, 'salesDeliveryAmount', chartDAmounts)
        this.$set(this.chartData, 'salesCommission', chartCommissions)

        let totals =  this.userRole == "BRAND" ? response.data.data.brand.monthlyTotals : [response.data.data.monthlyTotals]
        
        let totalTAmounts = []
        let totalDAmounts = []
        let totalCommissions = []

        if(this.userRole === "BRAND") {
          this.chartData.total = []
          this.chartLabels.forEach( (labelDate, labelIndex) => {
            let matchData = totals.find(t=> t.yearMonth === labelDate)

              totalTAmounts[labelIndex] = typeof matchData === "undefined" ? '' : Number(matchData.transactionAmount)
              totalDAmounts[labelIndex] = typeof matchData === "undefined" ? '' : Number(matchData.salesDeliveryAmount)
              totalCommissions[labelIndex] = typeof matchData === "undefined" ? '' : Number(matchData.salesCommission)
          })
        }

        this.$set(this.totalData, 'transactionAmount', totalTAmounts)
        this.$set(this.totalData, 'salesDeliveryAmount', totalDAmounts)
        this.$set(this.totalData, 'salesCommission', totalCommissions)
        

        this.createChart('transactionAmount');
      },
      
      createChartLabel() {
        this.date.startChartDate = this.date.startDate
        this.date.endChartDate = this.date.endDate

        let chartLabelsStarteDate = this.date.startChartDate
        let monthDiff = this.date.endChartDate.diff(this.date.startChartDate, 'months')

        this.chartLabels = []
        for(let i=0; i <= monthDiff; i++) {
          this.$set(this.chartLabels, i, this.$moment(chartLabelsStarteDate).format("YYYY-MM"))
          chartLabelsStarteDate = this.$moment(chartLabelsStarteDate.add(1, 'M'))
        }

        this.$moment(this.date.startChartDate.add(-1, 'M'))
      },
      
      createChart(arg) {
        let select = this.typeList.find(o => o.value == arg)
        this.typeSelect.label = select.label

        let chartData = {
          labels: this.chartLabels,
          datasets: this.storeSelect ? [this.chartData[arg].find(o => o.code == this.storeSelect)] : this.chartData[arg],
          options: {
            responsive: true,
            maintainAspectRatio: false
          }
        }
        
        let ctx = document.getElementById('planet-chart')
        let myChart = new Chart( ctx, {
          type: 'line',
          data: chartData,
        })
      },
      createChartExcel() {
        let excelData = [["매장", ...this.chartLabels]]

        this.chartData[this.typeSelect.value].forEach( chartRow => {
          let rowData = [chartRow.label, ...chartRow.data]
          excelData.push(rowData)
        })

        if(this.userRole === "BRAND") {
          let totalRow = ["합계", ...this.totalData[this.typeSelect.value]]
          excelData.push(totalRow)
        }

        const resultWS = xlsx.utils.aoa_to_sheet(excelData)
        const wb = xlsx.utils.book_new()
        xlsx.utils.book_append_sheet(wb, resultWS, this.typeSelect.label)
        xlsx.writeFile(wb, "월별정산레포트" + this.$moment().format('YYYYMDDhhmmss') + '.xlsx')
      }
    }
  }
</script>